<template>
    <div @click="clickHandler">
        <slot>
            <button class="button-third-party btn btn-block" :data-tpa-type="tpaType">
                <div class="icon-wrapper">
                    <svgIcon icon-holder-class="icon-third-party" icon-id="icon-apple-dark" />
                </div>
                <span class="social-text">Continue with Apple</span>
            </button>
        </slot>
    </div>
</template>

<script>
import queryString from 'query-string';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
    name: 'ButtonApple',
    components: {
        svgIcon,
    },
    props: {
        tpaType: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        oauthState: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            appleConfig: {
                scope: 'openid',
                response_type: 'code',
                redirect_uri: `${window.location.origin}/account/login/callback/apple`,
            },
            authorizeURI: 'https://appleid.apple.com/auth/authorize',
        };
    },
    computed: {
        client_id() {
            const env = process.env.VUE_APP_ENV !== 'prod' ? process.env.VUE_APP_ENV : '';
            return `com.nexon.arena.sign${env.toLowerCase()}`;
        },
    },
    methods: {
        clickHandler() {
            if (this.disabled || this.loading) return;

            this.$emit('click', 'Apple');

            const params = new URLSearchParams();

            params.set('response_type', this.appleConfig.response_type);
            params.set('client_id', this.client_id);
            params.set('redirect_uri', this.appleConfig.redirect_uri);
            params.set('scope', this.appleConfig.scope);

            const return_url = this.$route.query.return_url;
            const state = {
                ...(this.oauthState || {}),
                ...(return_url ? { return_url } : {}),
                ...(this.$route.query.unified ? { unified: 'unified' } : {}),
            };

            if (this.$store.state.isApplication) {
                state.clientCode = this.$uuid.v4();
                params.set('state', encodeURIComponent(queryString.stringify(state)));

                const url = `${this.authorizeURI}?${params.toString()}`;

                this.$router.push({
                    name: 'login-tpa-callback-app',
                    params: { clientCode: state.clientCode, socialProvider: 'Apple', url },
                });
            } else {
                if (Object.keys(state).length > 0) {
                    params.set('state', encodeURIComponent(queryString.stringify(state)));
                }

                // Web Popup login
                let apple_popup = window.open(
                    `${this.authorizeURI}?${params.toString()}`,
                    'Apple',
                    'width=660,height=670,top=300,left=800'
                );
                apple_popup.focus();
            }
        },
    },
};
</script>

<style lang="less" scoped>
button {
    background-color: #f0f0f0;
    &:hover {
        background-color: #fff;
    }
    &:focus {
        background-color: #c3c3c3;
    }
}

.button-third-party {
    margin: 0 0 10px;
    padding: 14px 0px;
    position: relative;
    .icon-wrapper {
        display: inline-flex;
        padding-right: 14px;
        vertical-align: middle;
        margin-top: -3px;
        .icon-third-party {
            width: 22px;
            height: 22px;
        }
    }
    .social-text {
        vertical-align: middle;
        color: #000000;
        font-size: 15px;
    }
}
</style>
